<template>
  <div class="plans-filter-sort">
    <div class="plans-filter-sort__label"></div>
    <div class="plans-filter-sort__dropdown">
      <div
        class="plans-filter-sort__trigger"
        :class="{ active: isDropdownOpen || selectedSort }"
        @click="toggleDropdown"
      >
        <span class="plans-filter-sort__text">
          {{ getSortLabel() }}
        </span>
        <div class="plans-filter-sort__arrow" :class="{ open: isDropdownOpen }">
          <Icon icon="arrow-dropdown" />
        </div>
      </div>

      <div v-if="isDropdownOpen" class="plans-filter-sort__dropdown-menu">
        <div class="plans-filter-sort__dropdown-content">
          <div
            v-for="sortOption in sortOptions"
            :key="sortOption.value"
            class="plans-filter-sort__dropdown-item"
            :class="{ active: selectedSort === sortOption.value }"
            @click="selectSort(sortOption.value)"
          >
            <span class="plans-filter-sort__dropdown-text">{{
              sortOption.label
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlansFilterSort",

  inject: ["filterStore"],

  data() {
    return {
      isDropdownOpen: false,
      selectedSort: "price_asc",
      sortOptions: [
        { value: "price_asc", label: "По возрастанию цены" },
        { value: "price_desc", label: "По убыванию цены" },
        { value: "area_asc", label: "По возрастанию площади" },
        { value: "area_desc", label: "По убыванию площади" },
      ],
    };
  },

  computed: {
    sortFilterActive() {
      return this.filterStore.state.filterSort;
    },
  },

  watch: {
    sortFilterActive: {
      handler(newValue) {
        if (newValue === null || newValue === undefined) {
          this.filterStore.setFilterSort(this.selectedSort);
        } else {
          this.selectedSort = newValue;
        }
      },
      immediate: true,
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    if (this.sortFilterActive === null || this.sortFilterActive === undefined) {
      this.filterStore.setFilterSort(this.selectedSort);
    }
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    getSortLabel() {
      const option = this.sortOptions.find(
        (opt) => opt.value === this.selectedSort
      );
      return option ? option.label : "По возрастанию цены";
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    selectSort(sortValue) {
      this.selectedSort = sortValue;
      this.filterStore.setFilterSort(sortValue);
      this.isDropdownOpen = false;
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.plans-filter-sort {
  display: flex;
  flex-direction: column;
  gap: 12px;
  user-select: none;

  @include md {
    gap: 30px;
  }

  @include xs {
    gap: 0;
  }

  &__label {
    height: 24px;

    @include md {
      height: 0;
    }
    
    @include sm {
      font-size: 12px;
    }
  }

  &__dropdown {
    position: relative;
  }

  &__trigger {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 358px;
    height: 56px;
    padding: 20px;
    border: 1px solid #e5e5e5;
    border-radius: 56px;
    background: #fff;
    color: inherit;
    font-size: 16px;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s;

    &::after {
      content: "";
      position: absolute;
      top: 3px;
      right: 3px;
      bottom: 3px;
      left: 3px;
      border: 1px solid #fff;
      border-radius: 50%;
      opacity: 0;
      transition: opacity 0.2s;
    }

    &:hover {
      border-color: #ff0020;
    }

    @include xl {
      width: auto;
      max-width: 358px;
    }

    @include sm {
      font-size: 12px;
      padding: 20px 15px;
    }
    
    @include xs {
      max-width: none;
    }
  }

  &__trigger.active::after {
    opacity: 0.2;
  }

  &__text {
    font-weight: 500;
  }

  &__arrow {
    width: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;
    color: #545863;

    svg {
      margin: 0;
      width: 12px;
      height: 5.5px;
      fill: none;
    }
  }

  &__arrow.open {
    transform: rotate(180deg);
  }

  &__dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    width: 100%;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    margin-top: 8px;
    overflow: hidden;
  }

  &__dropdown-content {
    max-height: 300px;
    overflow-y: auto;
    padding: 8px 0;
  }

  &__dropdown-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: background-color 0.2s;
    font-size: 14px;
    color: #291f1f;

    &:hover {
      background-color: #f8f8f8;
    }
  }

  &__dropdown-text {
    flex: 1;
    line-height: 1.4;
    font-size: 16px;
    font-weight: 500;

    @include sm {
      font-size: 12px;
    }
  }
}
</style>
